import { QUESTION_TYPE } from "../consts/survey";

export const getItensWeight = (items) => {
  return items.filter(
    (surveyItem) =>
      surveyItem.type !== QUESTION_TYPE.LABEL &&
      surveyItem.type !== QUESTION_TYPE.IMAGE &&
      // TODO Health score só está funcionando para NPS CES CSAT
      surveyItem.type !== QUESTION_TYPE.EMOJI &&
      surveyItem.type !== QUESTION_TYPE.MULTIPLE_CHOICE &&
      surveyItem.type !== QUESTION_TYPE.OPEN &&
      surveyItem.type !== QUESTION_TYPE.THUMBS &&
      surveyItem.type !== QUESTION_TYPE.RATINGS
  );
};
